<div class="header">
    <h2>{{ 'reflections.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="reflections-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'reflections.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'reflections.form.name' | translate"
            [placeholder]="'reflections.form.name.placeholder' | translate"
            inputId="name"
            testId="reflections-add-name"
        />
        <app-form-textarea
            [control]="form.controls.questionText"
            [label]="'reflections.form.questionText' | translate"
            [placeholder]="'reflections.form.questionText.placeholder' | translate"
            inputId="questionText"
            testId="reflections-add-question-text"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'reflections.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="reflections-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'reflections.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="reflections-add-submit"
        (onClick)="onSubmit()"
    />
</div>
